// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"e8a70a37","488":"e2b13431"}[chunkId] + ".chunk.js";
};